import { useState, useCallback } from 'react';

const useRoomDashboardFilters = () => {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    const dateParam = searchParams.get('date');
    const startDateParam = searchParams.get('startDate');
    const endDateParam = searchParams.get('endDate');

    const [activeTab, setActiveTab] = useState('1');
    const [dashboardDate, setDashboardDate] = useState(
        dateParam || new Date().toISOString().split('T')[0]
    );

    const [timelineRange, setTimelineRange] = useState({
        startDate: startDateParam,
        endDate: endDateParam,
    });

    const updateUrl = useCallback((params) => {
        const newUrl = new URL(window.location.href);
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                newUrl.searchParams.set(key, value);
            } else {
                newUrl.searchParams.delete(key);
            }
        });
        window.history.replaceState(null, '', newUrl);
    }, []);

    return {
        activeTab,
        setActiveTab,
        dashboardDate,
        setDashboardDate,
        timelineRange,
        setTimelineRange,
        updateUrl
    };
};

export default useRoomDashboardFilters;
